import { BarChart3, CheckCircle, Equal, FileText, Minus } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "src/v1/ui/accordion/accordion";
import { Badge } from "src/v1/ui/badge/badge";
import { Button } from "src/v1/ui/button-two/button";
import { Button as ButtonTwo } from "src/v1/ui/button/Button";
import { IcArrowRight } from "../../Landing/icons/IcArrowRight";
import { useLogging } from "../hooks/useLogging";

export default function PreDataLanding() {
  const navigate = useNavigate();
  const { logEvent, getPreviousPath } = useLogging();
  useEffect(() => {
    // Get previous path from various sources
    logEvent({
      name: "Page",
      value: "marketing landing",
      type: "Page",
      from: getPreviousPath(),
    });
  }, []);
  return (
    <div className="min-h-screen bg-white break-keep">
      <div className="bg-blue-950 text-white flex flex-col items-center p-4 gap-4">
        <Badge className="bg-[#007AFF] font-bold text-white py-2 px-3 rounded-full">
          한정 이벤트
        </Badge>
        <div className="flex flex-col gap-2 md:gap-4">
          <div className="text-center text-3xl md:text-4xl lg:text-5xl font-black px-4 leading-[2.5rem]">
            내 소송 지원금은 얼마?
          </div>
          <div className="text-center text-3xl md:text-4xl lg:text-5xl font-black px-4 leading-[2.5rem]">
            지금 바로 확인해보세요!
          </div>
        </div>
        <div className="flex flex-col gap-3 mt-4 md:px-4">
          <div className="text-lg md:text-xl text-center">
            실제 소송 지원금 적용 예시
          </div>
          <div className="bg-white rounded-xl p-4 flex flex-row gap-2 md:gap-4 items-center justify-center mb-4">
            <div className="text-black flex flex-col gap-1 items-center">
              <div className="text-sm md:text-base">소송비</div>
              <div className="text-lg md:text-2xl font-bold">500만원</div>
            </div>
            <div className="bg-blue-500 rounded-full flex items-center justify-center">
              <Minus className="text-white w-4 md:w-6 h-4 md:h-6" />
            </div>
            <div className="text-black flex flex-col gap-1 items-center">
              <div className="text-sm md:text-base">소송 지원금</div>
              <div className="text-lg md:text-2xl font-bold">490만원</div>
            </div>
            <div className="bg-blue-500 rounded-full flex items-center justify-center">
              <Equal className="text-white w-4 md:w-6 h-4 md:h-6" />
            </div>
            <div className="text-blue-600 font-bold flex flex-col gap-1 items-center">
              <div className="text-sm md:text-base">실 결제 금액</div>
              <div className="text-lg md:text-2xl font-bold">10만원</div>
            </div>
          </div>
          <Button
            onClick={() => navigate("/get-predata")}
            size="lg"
            id="calculation-start"
            variant="default"
            className="bg-[#007AFF] hover:bg-blue-700 text-white px-6 md:px-12 py-4 md:py-5 text-lg md:text-xl font-bold rounded-full shadow-lg mb-10 w-full md:w-auto mx-auto"
          >
            내 소송 지원금 확인하기
          </Button>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex flex-col items-center justify-center gap-3 mb-3">
              <h1 className="text-4xl md:text-5xl font-bold text-blue-600 ">
                아까운 내 돈, 이제 찾으셔야죠!
              </h1>
              <h1 className="text-md md:text-2xl font-bold text-gray-600 py-4">
                소송 지원금은 채권 회수시 발생하는 소송비를 <br /> 일부
                지원해드리는 공익 목적 서비스입니다.
              </h1>
            </div>

            <div className="flex flex-col items-center justify-center mb-16">
              <h2 className="text-2xl font-bold text-center text-gray-800 my-4">
                진단까지 3분이면 충분해요
              </h2>
              <div className="flex items-start gap-4 w-full">
                <div className="flex flex-col items-center flex-1">
                  <div className="bg-blue-100 w-fit p-2 md:p-3 rounded-full flex items-center justify-center mb-2 md:mb-4">
                    <FileText className="w-8 h-8 md:w-10 md:h-10 text-blue-600" />
                  </div>
                  <h3 className="font-bold text-sm md:text-lg mb-1 md:mb-2">
                    간단 정보 입력
                  </h3>
                  <p className="text-gray-600 text-xs md:text-base">
                    5가지 간단한 질문에 답변
                  </p>
                </div>

                <div className="flex flex-col items-center flex-1">
                  <div className="bg-green-100 w-fit p-2 md:p-3 rounded-full flex items-center justify-center mb-2 md:mb-4">
                    <BarChart3 className="w-8 h-8 md:w-10 md:h-10 text-green-600" />
                  </div>
                  <h3 className="font-bold text-sm md:text-lg mb-1 md:mb-2">
                    채권 전문 분석
                  </h3>
                  <p className="text-gray-600 text-xs md:text-base">
                    데이터 기반 지원금 계산
                  </p>
                </div>

                <div className="flex flex-col items-center flex-1">
                  <div className="bg-purple-100 w-fit p-2 md:p-3 rounded-full flex items-center justify-center mb-2 md:mb-4">
                    <CheckCircle className="w-8 h-8 md:w-10 md:h-10 text-purple-600" />
                  </div>
                  <h3 className="font-bold text-sm md:text-lg mb-1 md:mb-2">
                    내 사건 진단
                  </h3>
                  <p className="text-gray-600 text-xs md:text-base">
                    맞춤 서비스 + 지원 혜택 안내
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-4 mb-16 border border-gray-200">
            <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
              이미 많은 분들이 소송 지원 받고 내 돈을 찾았어요
            </h2>
            <div className="grid grid-cols-3  gap-2 md:gap-4 text-center">
              <div className="bg-white rounded-xl  shadow-sm flex flex-col text-center py-5">
                <div className="text-xl md:text-4xl font-bold text-blue-600 mb-2">
                  79%
                </div>
                <div className="text-gray-600 font-medium text-sm md:text-base">
                  채권 회수율
                </div>
              </div>
              <div className="bg-white rounded-xl  shadow-sm flex flex-col text-center py-5">
                <div className="text-xl md:text-4xl font-bold text-green-600 mb-2">
                  2.4만
                </div>
                <div className="text-gray-600 font-medium text-sm md:text-base">
                  수임 건수
                </div>
              </div>
              <div className="bg-white rounded-xl  shadow-sm flex flex-col text-center py-5">
                <div className="text-xl md:text-4xl font-bold text-purple-600 mb-2">
                  98%
                </div>
                <div className="text-gray-600 font-medium text-sm md:text-base">
                  최대 지원율
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4  flex flex-col items-center justify-center gap-4">
            <div className="text-center">
              <p className="text-blue-800 font-bold text-lg mb-2">
                ⚖️ 실력 있는 변호사들이 함께합니다.
              </p>
              <p className="text-blue-600 text-base">
                40년 법조 경력의 대표 변호사가 직접 사건을 검토하고 최적의 법적
                절차를 진행합니다
              </p>
            </div>
            <div>
              <ButtonTwo
                onClick={() => {
                  navigate("/company");
                }}
                variant="secondary"
                id="lawyer_click"
              >
                <span className="flex items-center gap-2 text-[12px] md:text-[16px]">
                  대표 변호사 소개
                  <IcArrowRight />
                </span>
              </ButtonTwo>
            </div>
          </div>

          {/* FAQ Section */}
        </div>
      </div>
      <div className=" bg-gray-50 p-6">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-4">
          자주 묻는 질문 (FAQ)
        </h2>
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            <AccordionItem value="item-1">
              <AccordionTrigger className="text-left text-sm sm:text-lg font-semibold text-gray-800 hover:text-blue-600">
                채권 금액이 소액이어도 지원 받을 수 있나요?{" "}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed md:text-lg">
                물론입니다. 채권도시는 적은 금액 단 돈 몇 만원부터 높은 금액까지
                어떠한 금액이라도 정당한 선의의 채권자의 채권은 지켜줘야 한다고
                믿습니다. "금액이 작아서 포기해야 하나?" 고민하지 마세요. 지금
                바로 소송 지원금 혜택 진단 받아보세요.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2">
              <AccordionTrigger className="text-left text-sm sm:text-lg font-semibold text-gray-800 hover:text-blue-600">
                지원금 안내 후 바로 소송 진행하고 싶은데 가능한가요?
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed md:text-lg">
                가능합니다. 예상 지원금 확인하시고, 이후 원하시는 상품을 선택해
                원클릭으로 결제까지 진행하실 수 있습니다. 이후 소송 절차를 즉시
                착수해 드립니다.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3">
              <AccordionTrigger className="text-left text-sm sm:text-lg font-semibold text-gray-800 hover:text-blue-600">
                지원금 계산을 위해 추가 서류가 필요한가요?
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed md:text-lg">
                지원금 계산은 무서류·무방문으로 3분 안에 모든 절차가 끝납니다.
                나의 채권 금액과 상황 등 단계별 내용만 정확히 입력해주세요.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-4">
              <AccordionTrigger className="text-left text-sm sm:text-lg font-semibold text-gray-800 hover:text-blue-600">
                회수 가능성이 얼마나 될지도 알 수 있나요?{" "}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed md:text-lg">
                네, 진단 결과 페이지에서 회수 가능성에 대해 함께 안내해
                드립니다. 이는 2만 건 이상의 실제 수임 데이터를 기반으로
                산출되므로 신뢰하셔도 좋습니다. 참고로 소송이나 추심에
                백프로라는 것은 없습니다만, 저희 법률사무소의 변호사님과
                요원들의 전문성 및 노하우로 최적화된 전략적 방법을 적용해 보통
                소송에 비하여 승소 확률이 높은 편입니다.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-5">
              <AccordionTrigger className="text-left text-sm sm:text-lg font-semibold text-gray-800 hover:text-blue-600">
                온라인 상담만 가능한가요?{" "}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed md:text-lg">
                저희 법률사무소는 모든 절차를 온라인으로 진행합니다. 온라인으로
                진행한다는 것이 아직은 생소하실 수 있습니다만, 오프라인 또는
                전화를 통해 직접 말로 전달하는 것보다 온라인에서 글로 전달하는
                것이 더 빠르고 정확하게 사건을 진행할 수 있는 방법입니다.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </div>
  );
}
